import { Flex, Image } from "@chakra-ui/react";
import { CustomText } from "@root/components/common/components";
import { ViewableImage } from "@root/components/common/images/viewAbleImage";
import { updateImagePopup } from "@root/store/slices/entities";
import { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useLocation } from "react-router-dom";
import { CHAT_TYPE, ROUTE_NAMES } from "@root/constants";
import { useTranslation } from "react-i18next";

function UserChat(props: any) {
  const { chat, editable } = props;
  const question = true;
  const questionType = true;
  const [, setInput] = useState("");
  const dispatch = useDispatch();
  const { filesPreview } = useMainChatContext();
  const { pathname } = useLocation();
  const isKCSChat = pathname.includes(ROUTE_NAMES.KCS);
  const { t } = useTranslation("common");

  const onImageClick = (url: string) => {
    dispatch(
      updateImagePopup({
        url,
      } as any)
    );
  };

  const userInput = useMemo(() => {
    const input = chat?.input || chat?.meta?.c?.question;
    if (!input) {
      return t("translate.explain");
    }
    // If chat type is 7 (verify), prepend "Verify: " to the question
    if (chat?.meta?.c?.type === CHAT_TYPE.VERIFICATION && input) {
      const verifyText = t("systemChat.verifyButton");
      const verifyPrefix = `${verifyText}: `;
      // Check if input already starts with the verify prefix to avoid duplication
      // This handles cases where useVerifyChat already added the prefix
      if (input.startsWith(verifyPrefix)) {
        return input;
      }
      return `${verifyPrefix}${input}`;
    }
    return input;
  }, [chat?.input, chat?.meta?.c?.question, chat?.meta?.c?.type, t]);

  return (
    <Flex
      flexDirection={"column"}
      justifyContent={"flex-end"}
      alignItems={"flex-start"}
      mt={"40px"}
      gap={"16px"}
      width={"100%"}
    >
      {question && questionType && (
        <Flex
          alignItems={"center"}
          borderRadius={"16px"}
          width={"100%"}
          justifyContent={"space-between"}
          gap={"16px"}
        >
          <Flex
            display={"block"}
            border={"1px solid"}
            borderColor={editable ? "theme.button.primary" : "transparent"}
            pt={"12px"}
            borderRadius={editable ? "8px" : "10px"}
            outline={0}
            justifyContent={"center"}
            alignItems={"center"}
            bgColor={"transparent"}
            width={"100%"}
            maxW={"100%"}
          >
            <CustomText
              contentEditable={editable}
              border={"1px solid"}
              borderColor={editable ? "theme.button.primary" : "transparent"}
              borderRadius={editable ? "8px" : "10px"}
              outline={0}
              fontSize={"24px"}
              text={userInput || ""}
              onInput={(e: any) => setInput(e?.target?.innerText)}
              width={"100%"}
              textAlign={"left"}
              isUserChat={isKCSChat}
              textColor={"#1A1A1A"}
              fontWeight={700}
            />
            <Image
              mt={4}
              mr={3}
              src={
                chat?.meta?.c?.signedUrl ||
                (filesPreview?.[0] && URL.createObjectURL(filesPreview?.[0]))
              }
            />

            <Flex gap={"16px"} flexWrap={"wrap"}>
              {chat?.selectedFiles &&
                chat?.selectedFiles?.length > 0 &&
                chat?.selectedFiles?.map((url: string) => (
                  <ViewableImage url={url} onClick={() => onImageClick(url)} />
                ))}
            </Flex>
          </Flex>
          {/* {mode === "search" ? (
            <SearchQuestionIcon />
          ) : mode === "chat" ? (
            <ChatQuestionIcon />
          ) : null} */}

          {/* {showEditOptions && (
            <UserEditOptions
              childChats={childchats}
              chatIndex={childChatIndex}
              onBack={onBack}
              childChatsLength={childChatsLength}
              onNext={onNext}
              setEditable={setEditable}
            />
          )} */}
          {/* {editable && (
            <Flex mt={"12px"}>
              <CustonButtom
                onClick={() => {
                  editSubmitHandler(input);
                  setEditable(false);
                }}
                height="37px"
                fontSize="12px"
                text="Save"
              />
              <CustonButtom
                onClick={() => setEditable(false)}
                height="37px"
                variant="light"
                fontSize="12px"
                text="Cancel"
              />
            </Flex>
          )} */}
        </Flex>
      )}
      {/* <Flex width={"100%"} flexDirection={"column"} gap={"6px"} mb="7px">
        <CustomText
          text={"Answer"}
          fontSize={"14px"}
          fontWeight={700}
          color={"#1A1A1A"}
          pl={"20px"}
          pb={"5px"}
        />
        <Flex alignItems={"flex-end"} width={"100%"} height={"3px"}>
          <Flex
            width={"20px"}
            height={"1px"}
            bgColor={"rgba(0, 0, 0, 0.12)"}
            flexShrink={0}
          />
          <Flex
            width={"56px"}
            height={"2px"}
            bgColor={"#1A1A1A"}
            flexShrink={0}
          />
          <Flex flex={1} height={"1px"} bgColor={"rgba(0, 0, 0, 0.12)"} />
        </Flex>
      </Flex> */}
    </Flex>
  );
}

export default UserChat;
